// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__oLLve","buttonCaption":"button_buttonCaption__3iyBZ","spinner":"button_spinner__356hc"};